import { createSlice } from "@reduxjs/toolkit";
import videoReducer from "@/components/VideoPage/redux/reducers";
import { videoInitialState } from "@/components/VideoPage/redux/initialState";

const videoSlice = createSlice({
  name: "video",
  initialState: videoInitialState,
  reducers: videoReducer,
});

export const { setLoading, setError, setVideoData, setDevice, setVideoSlug } = videoSlice.actions;

export default videoSlice.reducer;
